export default "__VITE_ASSET__BHrRUc5X__"